import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import Modal from '../components/Modal';
import { supabase } from '../config/supabase';

const PriveRegister = () => {
  const navigate = useNavigate();
  const [showModal, setShowModal] = useState(false);
  const [formData, setFormData] = useState({
    name: '',
    surname: '',
    dob: '',
    idNumber: '',
    email: '',
    password: '',
    confirmPassword: '',
    paymentOption: ''
  });
  const [error, setError] = useState('');

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value
    });
    setError('');
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    
    if (formData.password !== formData.confirmPassword) {
      setError('Passwords do not match!');
      return;
    }

    try {
      setError('');
      
      const { data: authData, error: authError } = await supabase.auth.signUp({
        email: formData.email,
        password: formData.password,
        options: {
          data: {
            full_name: `${formData.name} ${formData.surname}`,
            membership_tier: 'Platinum'
          }
        }
      });

      if (authError) {
        setError(authError.message);
        return;
      }

      const { error: userError } = await supabase
        .from('users')
        .insert([{
          id: authData.user.id,
          email: formData.email,
          full_name: `${formData.name} ${formData.surname}`,
          membership_tier: 'Platinum',
          status: 'pending'
        }]);

      if (userError) {
        setError(userError.message);
        return;
      }

      const { error: formError } = await supabase
        .from('application_forms')
        .insert([{
          user_id: authData.user.id,
          first_name: formData.name,
          last_name: formData.surname,
          email: formData.email,
          date_of_birth: formData.dob,
          membership_tier: 'Platinum',
          status: 'pending',
          areas_of_interest: formData.paymentOption ? [`Payment: ${formData.paymentOption}`] : []
        }]);

      if (formError) {
        setError(formError.message);
        return;
      }

      setShowModal(true);
      
    } catch (err) {
      setError(err.message || 'An error occurred during registration');
    }
  };

  return (
    <div className="page-container">
      <div className="page-wrapper">
        <img src="/assets/IBVlogo.png" alt="IBV Logo" className="company-logo" />

        <div className="card">
          <h2 className="section-title">Privé Package Registration</h2>
          <p className="page-subtitle">Choose your exclusive Privé membership below.</p>
          
          <div className="mb-lg">
            <p><strong>Options:</strong></p>
            <ul style={{ marginTop: '10px', paddingLeft: '20px' }}>
              <li>✔ R24,000 annually – Privé Member + Partner</li>
              <li>✔ R36,000 annually – Corporate (3 Members + Partners)</li>
            </ul>
          </div>

          <form onSubmit={handleSubmit}>
            <div className="form-group">
              <input type="text" name="name" className="form-input" placeholder="Name" value={formData.name} onChange={handleChange} required />
            </div>
            <div className="form-group">
              <input type="text" name="surname" className="form-input" placeholder="Surname" value={formData.surname} onChange={handleChange} required />
            </div>
            <div className="form-group">
              <input type="date" name="dob" className="form-input" value={formData.dob} onChange={handleChange} required />
            </div>
            <div className="form-group">
              <input type="text" name="idNumber" className="form-input" placeholder="ID Number" value={formData.idNumber} onChange={handleChange} required />
            </div>
            <div className="form-group">
              <input type="email" name="email" className="form-input" placeholder="Email Address" value={formData.email} onChange={handleChange} required />
            </div>
            <div className="form-group">
              <input type="password" name="password" className="form-input" placeholder="Create Password" value={formData.password} onChange={handleChange} required />
            </div>
            <div className="form-group">
              <input type="password" name="confirmPassword" className="form-input" placeholder="Confirm Password" value={formData.confirmPassword} onChange={handleChange} required />
            </div>
            <div className="form-group">
              <select name="paymentOption" className="form-select" value={formData.paymentOption} onChange={handleChange} required>
                <option value="">Select Payment Option</option>
                <option value="R24000 - Prive Member + Partner">R24,000 Annually – Privé Member + Partner</option>
                <option value="R36000 - Corporate (3 Members + Partners)">R36,000 Annually – Corporate (3 Members + Partners)</option>
              </select>
            </div>

            {error && <div className="alert alert-error">{error}</div>}

            <button type="submit" className="btn btn-primary">Submit Application</button>
            <button type="button" className="btn btn-secondary mt-md" onClick={() => navigate('/register')}>Back to Packages</button>
          </form>
        </div>

        <Modal isOpen={showModal} onClose={() => navigate('/login')}>
          <p>Thank you. Your application is being verified. We will contact you in 3–5 business days.</p>
          <button className="btn btn-primary mt-lg" onClick={() => navigate('/login')}>OK</button>
        </Modal>
      </div>
    </div>
  );
};

export default PriveRegister;
